import { render } from "./FunctionSettings.vue?vue&type=template&id=b7bfaf5a&scoped=true"
import script from "./FunctionSettings.vue?vue&type=script&lang=js"
export * from "./FunctionSettings.vue?vue&type=script&lang=js"

import "./FunctionSettings.vue?vue&type=style&index=0&id=b7bfaf5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bfaf5a"]])

export default __exports__